module.exports = __webpack_public_path__ + "media/images/pie/escu_raya2-1cf8ed77b70612e3c50e046a4c115f63.png";